import React, { useState } from 'react';
import { 
  ChevronDownIcon, 
  ChevronUpIcon, 
  ArrowRightIcon 
} from '@heroicons/react/24/outline';

const AcademicPrograms = () => {
  // Academic programs data with their respective qualifications
  const programs = [
    {
      id: 'business-management',
      title: 'BUSINESS AND MANAGEMENT',
      qualifications: [
        'Qualifi Level 3 Diploma in Business Management (603/1102/2)',
        'Qualifi Level 3 Diploma in Introduction to Management (603/4373/4)',
        'Qualifi Level 3 Integrated Diploma in Business and Management (603/4730/2)',
        'Qualifi Level 3 Diploma in Business Innovation and Entrepreneurship (603/1051/0)',
        'Qualifi Level 3 Extended Diploma in Business, Management and Study Skills (603/7380/5)',
        'Qualifi Level 3 Extended Diploma in Business Management (610/5596/7)',
        'Qualifi Level 3 Extended Diploma in Business and Law (610/5595/5)',
        'Qualifi Level 4 Diploma in Entrepreneurship (603/4238/9)',
        'Qualifi Level 4 Diploma in Business Management (601/6048/2)',
        'Qualifi Level 4 Diploma in Innovation and Future Foresight (610/2084/9)',
        'Qualifi Level 5 Diploma in Business Enterprise (601/6050/0)',
        'Qualifi Level 5 Diploma in Business Management (601/6049/4)',
        'Qualifi Level 5 Extended Diploma in Business Management (610/1675/5)',
        'Qualifi Level 6 Diploma in Business Administration (603/1037/6)',
        'Qualifi Level 6 Diploma in Business Management, Leadership and Innovation (603/7473/1)',
        'Qualifi Level 7 Diploma in Business Strategy (603/5745/9)',
        'Qualifi Level 7 Diploma in Ethical Leadership (603/4994/3)',
        'Qualifi Level 7 Diploma in Executive Management (601/7656/8)',
        'Qualifi Level 7 Diploma in Strategic Management and Innovation (603/2900/2)',
        'Qualifi Level 7 Diploma in Strategic Management and Leadership (601/5335/0)',
        'Qualifi Level 7 Diploma in Project Management (610/1342/0)',
        'Qualifi Level 7 Diploma in Risk Management (610/2175/1)',
        'Qualifi Level 8 Diploma in Strategic Management and Leadership (601/5362/3)'
      ]
    },
    {
      id: 'marketing',
      title: 'MARKETING',
      qualifications: [
        'Qualifi Level 7 Diploma in Strategic Marketing (610/2615/3)'
      ]
    },
    {
      id: 'health-social-care',
      title: 'HEALTH AND SOCIAL CARE',
      qualifications: [
        'Qualifi Level 2 Diploma in Care (603/5128/7)',
        'Qualifi Level 2 Adult Social Care Certificate (610/4201/8)',
        'Qualifi Level 3 Award in Basic Life Support and Management of Anaphylaxis (610/3072/7)',
        'Qualifi Level 3 Award in Emergency First Aid at Work (610/1767/X)',
        'Qualifi Level 3 Diploma in Health and Social Care (603/0819/9)',
        'Qualifi Level 3 Extended Diploma in Health and Social Care (610/5597/9)',
        'Qualifi Level 4 Diploma in Health and Social Care (601/5058/0)',
        'Qualifi Level 5 Diploma in Health and Social Care (601/5442/1)',
        'Qualifi Level 5 Extended Diploma in Health and Social Care (610/3288/8)',
        'Qualifi Level 7 Diploma in Health and Social Care (610/1483/7)',
        'Qualifi Level 7 Diploma in Relational Practice in Mental Health (610/2836/8)'
      ]
    },
    {
      id: 'psychology',
      title: 'PSYCHOLOGY',
      qualifications: [
        'Qualifi Level 4 Diploma in Psychology (610/2149/0)',
        'Qualifi Level 5 Diploma in Psychology (610/2124/6)',
        'Qualifi Level 5 Extended Diploma in Psychology (610/3465/4)',
        'Qualifi Level 7 Diploma in Psychology (610/2064/3)'
      ]
    },
    // Health and Safety Management
    {
      id: 'health-safety-management',
      title: 'HEALTH AND SAFETY MANAGEMENT',
      qualifications: [
        'Qualifi Level 6 Diploma in Health and Safety Management (610/2498/3)',
        'Qualifi Level 6 Diploma in Occupational Health and Safety Management (603/5226/7)',
        'Qualifi Level 7 Diploma in Occupational Health and Safety Management (610/2295/0)',
        'Qualifi Level 7 International Diploma in Occupational Health and Safety Management (603/5639/X)',
        'Qualifi Level 7 International Diploma in Process Safety Management (603/7608/9)'
      ]
    },
    // Hospitality and Tourism Management
    {
      id: 'hospitality-tourism',
      title: 'HOSPITALITY AND TOURISM MANAGEMENT',
      qualifications: [
        'Qualifi Level 3 Diploma in Hospitality and Tourism Management (603/4400/3)',
        'Qualifi Level 3 Extended Diploma in Hospitality and Tourism Management (610/5599/2)',
        'Qualifi Level 4 Diploma in Hospitality and Tourism Management (603/4399/0)',
        'Qualifi Level 5 Diploma in Hospitality and Tourism Management (603/4404/0)',
        'Qualifi Level 5 Extended Diploma in Hospitality and Tourism Management (610/3386/8)',
        'Qualifi Level 7 Diploma in Hospitality and Tourism Management (603/2655/4)'
      ]
    },
    // Human Resource Management
    {
      id: 'hr-management',
      title: 'HUMAN RESOURCE MANAGEMENT',
      qualifications: [
        'Qualifi Level 7 Diploma in Human Resource Management (603/0722/5)'
      ]
    },
    // Accounting and Finance
    {
      id: 'accounting-finance',
      title: 'ACCOUNTING AND FINANCE',
      qualifications: [
        'Qualifi Level 3 Diploma in Accounting and Finance (610/0795/X)',
        'Qualifi Level 4 Diploma in Accounting and Finance (610/0796/1)',
        'Qualifi Level 5 Diploma in Accounting and Finance (610/0797/3)',
        'Qualifi Level 5 Extended Diploma in Accounting and Finance (610/3329/7)',
        'Qualifi Level 7 Diploma in Accounting and Finance (603/0723/7)',
        'Qualifi Level 7 Diploma in Asset-based Lending (610/0642/7)',
        'Qualifi Level 7 Diploma in Family Office and Wealth Inheritance Management (610/2921/X)'
      ]
    },
    // Information Technology (IT)
    {
      id: 'it',
      title: 'INFORMATION TECHNOLOGY',
      qualifications: [
        // Level 3
        'Level 3: Qualifi Level 3 Diploma in Information Technology (610/0659/2)',
        'Level 3: Qualifi Level 3 Extended Diploma in IT and Cyber Security (610/5598/0)',
        'Level 3: Qualifi Level 3 Extended Diploma in IT and Data Science (610/5600/5)',
        // Level 4
        'Level 4: Qualifi Level 4 Diploma in Information Technology (603/4781/8)',
        'Level 4: Qualifi Level 4 Diploma in IT - Networking (603/4782/X)',
        'Level 4: Qualifi Level 4 Diploma in IT - Web Design (603/4783/1)',
        'Level 4: Qualifi Level 4 Diploma in IT - E-commerce (603/4786/7)',
        'Level 4: Qualifi Level 4 Diploma in Internet of Things (Smart Home) (610/5031/3)',
        // Level 5
        'Level 5: Qualifi Level 5 Diploma in Information Technology (603/4730/0)',
        'Level 5: Qualifi Level 5 Diploma in IT - Networking (603/4792/2)',
        'Level 5: Qualifi Level 5 Diploma in IT - Web Design (603/4793/4)',
        'Level 5: Qualifi Level 5 Diploma in IT - E-commerce (603/4794/6)',
        'Level 5: Qualifi Level 5 Extended Diploma in Networking and Cyber Security (610/3042/9)',
        'Level 5: Qualifi Level 5 Extended Diploma in Information Technology (610/3474/5)',
        'Level 5: Qualifi Level 5 Extended Diploma in IT-Networking (610/3475/7)',
        'Level 5: Qualifi Level 5 Extended Diploma in IT-Web Design (610/3478/9)',
        'Level 5: Qualifi Level 5 Extended Diploma in IT E-commerce (610/3477/0)',
        // Level 7
        'Level 7: Qualifi Level 7 Diploma in IT (610/2170/9)'
      ]
    },
    // Law and Legal Services
    {
      id: 'law-legal',
      title: 'LAW AND LEGAL SERVICES',
      qualifications: [
        'Qualifi Level 3 Diploma in Law (610/1282/8)',
        'Qualifi Level 4 Diploma in Law (610/1091/1)',
        'Qualifi Level 5 Diploma in Law (610/1092/3)',
        'Qualifi Level 3 Extended Diploma in Business and Law (610/5595/5)',
        'Qualifi Level 5 Extended Diploma in Law (610/3349/2)',
        'Qualifi Level 7 Diploma in Law (610/2558/6)',
        'Qualifi Level 7 Diploma in International Business Law (603/4199/3)'
      ]
    },
    // Data Science
    {
      id: 'data-science',
      title: 'DATA SCIENCE',
      qualifications: [
        'Qualifi Level 3 Diploma in Data Science (610/1950/1)',
        'Qualifi Level 3 Extended Diploma in IT and Data Science (610/5600/5)',
        'Qualifi Level 4 Diploma in Artificial Intelligence (610/3934/2)',
        'Qualifi Level 5 Diploma in Artificial Intelligence (610/3935/4)',
        'Qualifi Level 7 Diploma in Data Science (603/6693/X)'
      ]
    },
    // Cyber Security
    {
      id: 'cyber-security',
      title: 'CYBER SECURITY',
      qualifications: [
        'Qualifi Level 2 Diploma in Business Beginners in Cyber Security (603/3329/7)',
        'Qualifi Level 3 Diploma in Cyber Security Management and Operations (603/3334/0)',
        'Qualifi Level 3 Extended Diploma in IT and Cyber Security (610/5598/0)',
        'Qualifi Level 4 Diploma in Cyber Security (603/3331/5)',
        'Qualifi Level 5 Diploma in Cyber Security (603/4139/7)',
        'Qualifi Level 5 Extended Diploma in Cyber Security (610/3296/7)',
        'Qualifi Level 7 Diploma in Cyber Security (610/3596/8)'
      ]
    },
    // Logistics and Supply Chain Management
    {
      id: 'logistics',
      title: 'LOGISTICS AND SUPPLY CHAIN MANAGEMENT',
      qualifications: [
        'Qualifi Level 7 Diploma in Logistics and Supply Chain Crisis Management (603/607/7)'
      ]
    },
    // Early Years Education
    {
      id: 'early-years',
      title: 'EARLY YEARS EDUCATION',
      qualifications: [
        'Qualifi Level 3 Diploma in Early Years Education and Care (Early Years Educator) (610/0013/6)',
        'Qualifi Level 3 Diploma in Specialist Support for Teaching and Learning in Schools (603/7690/9)',
        'Qualifi Level 4 Diploma in Early Learning and Childcare (610/0227/6)',
        'Qualifi Level 5 Diploma in Early Learning and Childcare (610/0226/4)'
      ]
    },
    // Education and Training
    {
      id: 'education-training',
      title: 'EDUCATION AND TRAINING',
      qualifications: [
        'Qualifi Level 3 Award in Education and Training (603/5680/7)',
        'Qualifi Level 4 Certificate in Education and Training (603/6042/2)',
        'Qualifi Level 4 Diploma in Education and Training (610/3647/X)',
        'Qualifi Level 5 Diploma in Education and Training (603/6055/0)',
        'Qualifi Level 5 Extended Diploma in Education and Training Management (610/3648/1)',
        'Qualifi Level 7 Diploma in Educational Management and Leadership (603/6176/1)'
      ]
    },
    // Teaching and Coaching
    {
      id: 'teaching-coaching',
      title: 'TEACHING AND COACHING',
      qualifications: [
        'Qualifi Level 3 Certificate in Teaching English as a Foreign Language (TEFL) (The TEFL Academy) (603/7201/1)',
        'Qualifi Level 5 Certificate in Observed Teaching Practice (TEFL) (The TEFL Academy) (603/4315/1)',
        'Qualifi Level 5 Diploma in Teaching English as a Foreign Language (TEFL) (The TEFL Academy) (603/3835/0)',
        'Qualifi Level 5 Diploma in Teaching English to Speakers of Other Languages (TESOL) (The TEFL Academy) (603/3864/7)',
        'Qualifi Level 5 Certificate in Teaching English as a Foreign Language with Practice (CertTEFL) (The TEFL Academy) (603/5428/8)',
        'Qualifi Level 5 Diploma in Health and Wellness Coaching (603/1558/6)',
        'Qualifi Level 6 Diploma in Global Teaching Practice (603/5814/7)',
        'Qualifi Level 6 Extended Diploma in Global Teaching Practice (603/6815/9)',
        'Qualifi Level 4 Diploma in Coaching (603/1380/4)',
        'Qualifi Level 7 Diploma in Integrative Sport and Exercise Nutrition (603/3669/3)'
      ]
    },
    // Sports Coaching
    {
      id: 'sports-coaching',
      title: 'SPORTS COACHING',
      qualifications: [
        'Qualifi Level 3 Diploma in the Principles of Cricket Coaching (R661 Academy) (610/3153/7)',
        'Qualifi Level 3 Certificate in Activating High Performance in Soccer Coaching (610/3527/0)'
      ]
    },
    // Aesthetic Practice
    {
      id: 'aesthetic-practice',
      title: 'AESTHETIC PRACTICE',
      qualifications: [
        'Qualifi Level 3 Award in Basic Life Support and Management of Anaphylaxis in Clinical Practice (610/5316/8)',
        'Qualifi Level 4 Certificate in Anatomy and Physiology for Aesthetics Practice (603/7469/X)',
        'Qualifi Level 4 Certificate in Plasma Skin Rejuvenation (603/7775/6)',
        'Qualifi Level 4 Certificate in Microblading to Enhance Eyebrows (603/7797/5)',
        'Qualifi Level 4 Certificate in Micropigmentation to Enhance Eyebrows (603/7851/7)',
        'Qualifi Level 4 Certificate in Micropigmentation to Enhance Eyes (603/7799/9)',
        'Qualifi Level 4 Certificate in Micropigmentation to Enhance Lips (603/7798/7)',
        'Qualifi Level 4 Diploma in Micropigmentation (603/7789/6)',
        'Qualifi Level 4 Certificate in Aesthetic Practice (610/1195/2)',
        'Qualifi Level 4 Award in Laser Core of Knowledge (610/5706/X)',
        'Qualifi Level 4 Certificate in Laser, Light and Energy-Based Procedures (610/1194/0)',
        'Qualifi Level 4 Diploma in Aesthetic Procedures for Skin Rejuvenation (610/1193/9)',
        'Qualifi Level 5 Certificate in Tattoo Fade and Removal (610/5707/1)',
        'Qualifi Level 5 Certificate in Aesthetic Practice (603/5205/7)',
        'Qualifi Level 7 Certificate in Aesthetic Practice (603/6210/3)'
      ]
    },
    // Beauty Therapy
    {
      id: 'beauty-therapy',
      title: 'BEAUTY THERAPY',
      qualifications: [
        'Qualifi Level 2 Diploma in Beauty Therapy (603/7713/6)',
        'Qualifi Level 2 Diploma in Beauty Treatments (603/7714/8)',
        'Qualifi Level 2 Certificate in Facial Skincare (603/7715/X)',
        'Qualifi Level 2 Certificate in Lash and Brow Treatments (603/7716/1)',
        'Qualifi Level 2 Certificate in Nail Treatments (603/7717/3)',
        'Qualifi Level 2 Certificate in Waxing Treatments (603/7718/5)',
        'Qualifi Level 2 Certificate in Makeup Techniques (603/7719/7)',
        'Qualifi Level 3 Diploma in Advanced Beauty Therapy (610/0610/5)',
        'Qualifi Level 3 Diploma in Body Electrotherapy (610/0611/7)',
        'Qualifi Level 3 Diploma in Epilation (610/0612/9)',
        'Qualifi Level 3 Certificate in Facial Electrotherapy (610/0613/0)',
        'Qualifi Level 3 Certificate in Advanced Lashes and Brow Lamination (610/0614/2)',
        'Qualifi Level 3 Certificate in Intimate Waxing (610/0615/4)'
      ]
    },
    // Hairdressing
    {
      id: 'hairdressing',
      title: 'HAIRDRESSING',
      qualifications: [
        'Qualifi Level 2 Diploma in Hairdressing (603/7726/4)',
        'Qualifi Level 2 Certificate in Cut and Finish Hair Services (603/7727/6)',
        'Qualifi Level 2 Certificate in Colour and Lighten Hair Services (603/7728/8)',
        'Qualifi Level 2 Certificate in Set, Style, and Finish Hair Services (603/7729/X)',
        'Qualifi Level 2 Certificate in Smoothing and Straightening Hair Services (603/7730/6)',
        'Qualifi Level 2 Diploma in Barbering (GBBA) (610/0691/9)',
        'Qualifi Level 3 Diploma in Advanced and Creative Hairdressing (610/0503/4)',
        'Qualifi Level 3 Certificate in Advanced and Creative Hairdressing (610/0502/2)'
      ]
    },
    // Wellness
    {
      id: 'wellness',
      title: 'WELLNESS',
      qualifications: [
        'Qualifi Level 3 Diploma in Wellbeing and Holistic Therapies (610/0176/4)',
        'Qualifi Level 3 Certificate in Spa and Wellness Experiences (610/0177/6)',
        'Qualifi Level 3 Certificate in Massage (610/0178/8)',
        'Qualifi Level 3 Certificate in Anatomy, Physiology and Pathology (610/0179/X)',
        'Qualifi Level 3 Diploma in Massage Therapy (610/0182/X)',
        'Qualifi Level 3 Certificate in Thai Massage (610/0193/4)',
        'Qualifi Level 5 Diploma in Nutrition and Health Coaching (610/2579/3)',
        'Qualifi Level 5 Diploma in Coaching for Lifestyle and Wellbeing Management (610/2580/X)',
        'Qualifi Level 5 Certificate in Human Nutrition and Gut Microbiome (610/2578/1)',
        'Qualifi Level 5 Certificate in Wellbeing Coaching (610/2581/7)',
        'Qualifi Level 7 Diploma in Health and Wellness Coaching (603/2953/1)'
      ]
    },
    // Help Section
    {
      id: 'help-section',
      isHelpSection: true,
      title: 'Need Help Choosing a Program?',
      content: 'Our academic advisors are here to help you find the program that best matches your interests and career goals.'
    }
  ];

  // State to track which accordion is open
  const [openAccordion, setOpenAccordion] = useState(null);

  // Toggle accordion with smooth scrolling
  const toggleAccordion = (id) => {
    setOpenAccordion(prevId => prevId === id ? null : id);
    
    // Smooth scroll to the opened accordion
    if (openAccordion !== id) {
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  };

  const renderPrograms = () => {
    return programs.map((program) => {
      if (program.isHelpSection) {
        return (
          <div key={program.id} className="bg-gray-50 p-6 rounded-lg mb-6 text-center">
            <h3 className="text-xl font-semibold text-gray-800 mb-2">{program.title}</h3>
            <p className="text-gray-600">{program.content}</p>
          </div>
        );
      }

      return (
      <React.Fragment key={program.id}>
        <div 
          id={program.id}
          className="bg-[#800000] rounded-lg overflow-hidden shadow-lg transition-all duration-200 border border-gray-200"
        >
          <button
            className={`w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none transition-all duration-300 ${
              openAccordion === program.id ? 'bg-[#990000]' : 'bg-[#800000] hover:bg-[#990000]'
            }`}
            onClick={() => toggleAccordion(program.id)}
            aria-expanded={openAccordion === program.id}
            aria-controls={`${program.id}-content`}
          >
            <span className="text-white font-bold text-lg md:text-xl">{program.title}</span>
            <div className="flex items-center">
              <span className="text-white/70 text-sm mr-3 hidden sm:inline">
                {openAccordion === program.id ? 'Hide qualifications' : 'View qualifications'}
              </span>
              <div className={`transform transition-transform duration-300 ${
                openAccordion === program.id ? 'rotate-180' : ''
              }`}>
                <ChevronDownIcon className="h-6 w-6 text-white" />
              </div>
            </div>
          </button>
          
          <div
            id={`${program.id}-content`}
            className={`overflow-hidden transition-all duration-300 ease-in-out bg-white ${
              openAccordion === program.id ? 'max-h-[2000px] py-6' : 'max-h-0 py-0'
            }`}
            aria-hidden={openAccordion !== program.id}
          >
            <div className="px-6 pb-6">
              {program.qualifications.length > 0 ? (
                <ul className="list-disc pl-5 space-y-2">
                  {program.qualifications.map((qualification, qIndex) => (
                    <li key={qIndex} className="text-gray-700">
                      {qualification}
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-gray-500 italic">
                  Qualification details coming soon. Please check back later.
                </p>
              )}
            </div>
          </div>
        </div>
      </React.Fragment>
      );
    });
  };

  return (
    <div className="w-full">
      {/* Hero Section */}
      <div className="bg-[#800000] text-white py-16 md:py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Academic Programs
          </h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto opacity-90">
            Explore our comprehensive range of accredited qualifications designed to help you achieve your academic and career goals.
          </p>
        </div>
      </div>
      
      {/* Academic Offerings Section */}
      <div className="bg-white py-12 md:py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Our Academic Offerings
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
            Browse through our diverse range of programs and find the perfect fit for your academic journey.
          </p>
        </div>
      </div>
      
      {/* Programs Section */}
      <div className="w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pb-12">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">
          Our Academic Programs
        </h2>
        
        <div className="space-y-3 max-w-4xl mx-auto">
          {renderPrograms()}
        </div>
      </div>
    </div>
  );
};

export default AcademicPrograms;